<template>
  <base-view :activeTab="activeTab"></base-view>
</template>

<script>
export default {
  name: "gpt",
  data() {
    return {
      activeTab: "gpt"
    };
  },
  components: {
    BaseView: () => import("@/components/BaseView.vue"),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
